/**
 * #3981 — suggested workspace name derived from the user's display name.
 *
 * SSO logins (Google/Microsoft) capture the provider display name into
 * `profile.name` (auth-sso.router.ts), so the naming screen can prefill
 * "<FirstName>'s Workspace" — one tap to accept, fully editable. Magic-link
 * users have no captured name; an empty/blank input yields '' so the field
 * stays blank with its placeholder.
 */
export function suggestWorkspaceName(
  fullName: string | null | undefined,
): string {
  const trimmed = (fullName ?? "").trim();
  if (!trimmed) return "";
  const firstName = trimmed.split(/\s+/)[0];
  return `${firstName}'s Workspace`;
}
